import React from "react";
import C from "classnames";

import S from "./_styles.module.scss";

export interface TopPanelProps {
  id?: string;
  children?: React.ReactNode;
  className?: string;
  panelRef?: React.Ref<HTMLDivElement>;
  isResizing?: boolean;
}

const TopPanel: React.FC<TopPanelProps> = ({ children, className, panelRef, isResizing, id }) => {
  return (
    <div
      id={id}
      className={C(S.topPanel, "p-splitter-panel", className)}
      role="presentation"
      ref={panelRef}
    >
      <div className="h-full relative">
        {React.Children.map(children, (child, index) =>
          React.isValidElement(child) ? React.cloneElement(child, { key: index }) : child
        )}
        <div className={C(S.resizingOverlay, isResizing && S.visible)}></div>
      </div>
    </div>
  );
};

export default TopPanel;
